<template>
    <div class="must-have-exactly-one-root-element">

        <!-- Header -->
        <header-login/>

        <!-- Main -->
        <main class="registerScreen">
            <div class="container-fluid">
                <div class="row --mainRow">
                    <!-- Left img -->
                    <div class="col-xs-12 col-md-4 col-lg-4 col-xl-6 d-none d-xl-block --loginBg leftCol"></div>

                    <!-- Registrácia -->
                    <div class="col-xs-12 col-md-12 col-lg-12 col-xl-6 rightCol">
                        <ol id="scrollReg" class="m-stepNavigation">
                            <li class="a-stepNavigation__item">Registrácia</li>
                        </ol>

                        <div class="paddingBox">
                            <h2>Registrácia</h2> 

                            <!-- Alert box -->
                            <div v-if="responseText != ''" :class="'alert alert-'+responseType" role="alert">
                                <span :class="'icon --'+responseType"></span>{{ responseText }}&nbsp;
                                <router-link v-if="responseType == 'success'" :to="{ name: 'login', params: { reset: true } }" style="color:#4CAF50; text-decoration:underline">Prihlásiť sa</router-link>
                            </div>   

                            <div class="row">
                                <div class="col-lg-7 col-xl-7">

                                    <!-- Switch -->
                                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                                        <a :class="'nav-item nav-link show' + active0" id="jednotlivec-tab" role="tab" @click="regType('jednotlivec')">
                                            <span class="icon --jednotlivec"></span>Jednotlivec
                                        </a>
                                        <a :class="'nav-item nav-link show' + active1" id="kolektiv-tab" role="tab" @click="regType('kolektiv')">
                                            <span class="icon --kolektiv"></span>Kolektív
                                        </a>
                                    </div>

                                    <!-- Form -->
                                    <div class="tab-content" id="nav-tabContent">
                                        <div class="tab-pane fade show active" id="jednotlivec" role="tabpanel" aria-labelledby="jednotlivec-tab">

                                            <!-- Form Box -->
                                            <form @submit="formSubmit">
                                                <div class="form-row">
                                                    <div class="col-12 col-md-12">
                                                        <label for="meno-jednotlivec">Meno *</label>
                                                        <input type="text" class="form-control" v-model="meno" required>
                                                    </div>
                                                </div>
                                                <div class="form-row">
                                                    <div class="col-12 col-md-12">
                                                        <label for="email-jednotlivec">E-mail *</label>
                                                        <input type="email" class="form-control" v-model="email" required>
                                                    </div>
                                                </div>
                                                <div class="form-row">
                                                    <div class="col-12 col-md-12">
                                                        <label for="password-jednotlivec">Heslo *</label>
                                                        <input type="password" class="form-control" v-model="heslo" required>
                                                    </div>
                                                </div>
                                                <div class="form-row">
                                                    <div class="col-12 col-md-12">
                                                        <label for="okres-jednotlivec">Okres</label>
                                                        <select type="text" class="custom-select" @change="onChange($event.target.value)">
                                                            <option v-for="item in okresy" :value="item.name">{{ item.name }}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="form-row">
                                                    <div class="col-12">
                                                        <div class="custom-control custom-checkbox mb-2">
                                                            <input type="checkbox" class="custom-control-input" id="customCheck1" v-model="suhlas1" required>
                                                            <label class="custom-control-label" for="customCheck1">Mám záujem o registráciu na stránke adoptujkravicku.sk a o účasť v súťaži, ktorej organizácia sa spravuje <a target="_blank" href="https://www.adoptujkravicku.sk/pravidla-pouzivania/">Pravidlami súťaže</a>.*</label>
                                                        </div>
                                                        <div class="custom-control custom-checkbox mb-2">
                                                            <input type="checkbox" class="custom-control-input" id="customCheck2" v-model="suhlas2" required>
                                                            <label class="custom-control-label" for="customCheck2">Súhlasím so spracúvaním mojich osobných údajov za podmienok uvedených v <a target="_blank" href="https://www.adoptujkravicku.sk/pravidla-ochrany-osobnych-udajov/">Pravidlách ochrany osobných údajov</a> spojených s prevádzkou webovej stránky adoptujkravičku.sk.*</label>
                                                        </div>
                                                        <div class="custom-control custom-checkbox mb-2">
                                                            <input type="checkbox" class="custom-control-input" id="customCheck3" v-model="suhlas3">
                                                            <label class="custom-control-label" for="customCheck3">Súhlasím so zasielaním marketingových informácií o slovenskom mlieku a mliečnych výrobkoch rôznych slovenských výrobcov na môj e-mail za podmienok uvedených v <a target="_blank" href="https://www.adoptujkravicku.sk/pravidla-ochrany-osobnych-udajov/">Pravidlách ochrany osobných údajov</a> spojených s prevádzkou webovej stránky adoptujkravičku.sk.</label>
                                                        </div>
                                                        <p>Údaje označené hviezdičkou sú povinné.</p>
                                                    </div>
                                                </div>
                                                <div class="form-row">
                                                    <div class="col-12 col-md-12">
                                                        <button class="btn --primary w-100" @click.native="$scrollToTop">
                                                            Registrovať sa <span class="icon"></span>
                                                        </button>
                                                        <!-- Solo -->
                                                        <!--<span v-if="skupina == 0">
                                                            <div class="m-separator text-center">
                                                                <span>alebo</span>
                                                            </div>
                                                            <button class="btn --primary w-100 --facebookNormal">
                                                                Prihlásiť sa cez Facebook <span class="icon d-none d-md-inline-block"></span>
                                                            </button>
                                                        </span>-->
                                                    </div>
                                                </div>
                                            </form>
                                            <!-- .Form Box -->

                                            <div class="form-row">
                                                <div class="col-12 col-md-12">
                                                    <!-- Solo -->
                                                    <span v-if="skupina == 0">
                                                        <div class="m-separator text-center">
                                                            <span>alebo</span>
                                                        </div>
                                                        <button @click="fbLogin" class="btn --primary w-100 --facebookNormal">
                                                            Prihlásiť sa cez Facebook <span class="icon d-none d-md-inline-block"></span>
                                                        </button>
                                                    </span>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <!-- .Form -->

                                </div>

                                <!-- Benefity -->
                                <div class="col-lg-5 col-xl-5">
                                    <aside class="o-widget mb-md-5">        
                                        <div class="m-widgetContent">
                                            <div class="m-widgetContent__description">
                                                <p>Tu sa môžeš zaregistrovať a adoptovať si tak svoju kravičku.</p>
                                                <h2>Benefity:</h2>
                                            </div>
        
                                            <ul class="m-widgetContent__list">
                                                <li>zaregistruj sa a môžeš si tú svoju kravičku vybrať a dať jej meno</li>
                                                <li>zaregistruj sa a môžeš svoju kravičku prísť pozrieť na farmu</li>
                                                <li>zaregistruj sa, súťaž a vyhraj pekné ceny</li>
                                            </ul>
                                        </div>
                                    </aside>
                                </div>
                                <!-- .Benefity -->

                            </div>
                        </div>
                    </div>
                    <!-- .Registrácia -->

                </div>
            </div>
        </main>
        <!-- .Main -->

    </div>
</template>



<script>
    import EventService from '@/services/EventService.js'
    import HeaderLogin  from './partials/HeaderLogin.vue'
    import json         from '@/services/okresy.json'
    export default {
        components: {
            HeaderLogin
        },
        mounted() {
            this.emitResetProfil()
        },
        data() {
            return {
                okresy: json,

                active0: ' active',
                active1: '',

                meno: '',
                email: '',
                heslo: '',
                okres: json[0].name,
                suhlas1: '',
                suhlas2: '',
                suhlas3: '',
                skupina: '',

                responseType: '',
                responseText: ''
            }
        },
        methods: {
            // emit
            emitResetProfil() {
                this.$emit('resetProfil')
            },


            // select
            onChange(value) {
                this.okres = value
            },


            // submit
            formSubmit(e) {
                e.preventDefault()
                document.getElementById("scrollReg").scrollIntoView()
                this.register()
            },

            register() {
                EventService.register(this.meno, this.email, this.heslo, this.okres, this.suhlas1, this.suhlas2, this.suhlas3, this.skupina)
                    .then(response => {
                        //console.log(response.data)
                        this.responseType = response.data.code
                        this.responseText = response.data.data

                        this.$gtm.trackEvent({
                            event: 'Registration',
                            category: 'form',
                            action: 'submit',
                            label: 'registration',
                            value: 'successful',
                        });

                        if (response.data.code == 'success') {
                            // nemáme token takže ho nevieme automaticky prihlásiť
                            //EventService.saveTokenToSession(response.data.data.token)
                            //this.$router.push({ name: 'profil' })
                        }
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            },


            // click
            regType(typ) {
                if (typ == 'jednotlivec') {
                    this.active0 = ' active'
                    this.active1 = ''
                    this.skupina = 0
                } else {
                    this.active0 = ''
                    this.active1 = ' active'
                    this.skupina = 1
                }
            },

            fbLogin() {
                // window.location.replace("https://www.adoptujkravicku.sk/hra/")
                let self = this
                FB.login(function(response) {
                    if (response.authResponse) {

                        FB.api('/me', {fields: 'name, email'}, function(userData) {
                            EventService.fbLogin(userData)
                                .then(response => {
                                    self.initAcl()
                                    EventService.saveTokenToSession(response.data.data.access_token)
                                    sessionStorage.setItem("login", "success")
                                    self.$router.push({ name: 'profil' })
                                })
                                .catch(error => {
                                    self.responseType = 'warning'
                                    self.responseText = error
                                })
                        });

                    } else {
                        console.log('User cancelled login or did not fully authorize.');
                    }
                },  { scope: 'email' });
            },

            initAcl() {
                EventService.initializeAcl()
                    .then(response => {
                        console.log(response)
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            },
        }
    }
</script>